module.exports = __webpack_public_path__ + "static/media/datacult.17903523.png";